import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";
import type { ProductType } from "@/api_client";
import type { Locales } from "@/graphql/generated";
import type { EntryContentByProductType } from "../../contentTypes/entry/generalEntryTypes";
import { entryContentQueryOptions } from "../queryOptions/entryContentQueryOptions";

export const useEntryContent = <P extends ProductType = ProductType>(
  externalContent?: EntryContentByProductType<P> | null,
) => {
  const params = useParams<{
    language: Locales;
    product: P;
  }>();

  const { language, product } = params ?? {
    language: undefined,
    product: undefined,
  }; // Handle the case where params might be undefined because of not in Next.js page/component

  const query = useQuery({
    ...entryContentQueryOptions(product, language),
    enabled: externalContent == null,
  });

  return {
    ...query,
    data: externalContent ?? query.data,
  };
};
